module.exports = __webpack_public_path__ + "static/btc-coin-8227f2b9f0fcef8b588cecd9b1bcae7a.png";